import React from 'react'
import useTurnstileScript from './useTurnstileScript'

const Turnstile = React.forwardRef(({ siteKey, onVerify, onExpire, onError, theme, size }, ref) => {
  const { loaded, error: scriptError } = useTurnstileScript()
  const containerRef = React.useRef()
  const widgetIdRef = React.useRef()

  React.useImperativeHandle(ref, () => ({
    reset: () => {
      if (window.turnstile && widgetIdRef.current) {
        window.turnstile.reset(widgetIdRef.current)
      }
    },
  }))

  React.useEffect(() => {
    if (scriptError && onError) {
      onError()
    }
  }, [scriptError])

  React.useEffect(() => {
    if (loaded && containerRef.current && !widgetIdRef.current) {
      widgetIdRef.current = window.turnstile.render(containerRef.current, {
        sitekey: siteKey,
        theme: theme || 'auto',
        size: size || 'normal',
        appearance: 'always',
        callback: onVerify,
        'expired-callback': onExpire,
        'error-callback': onError,
      })
    }
    return () => {
      if (window.turnstile && widgetIdRef.current) {
        window.turnstile.remove(widgetIdRef.current)
        widgetIdRef.current = undefined
      }
    }
  }, [loaded])

  return <div ref={containerRef} />
})

export default Turnstile
